import React from 'react';

const SvgArrowBack2 = () => (
  <svg viewBox="0 0 20 20" width="1em" height="1em">
    <path d="M12.7 2.5L5.2 10l7.4 7.5 2.1-2.1L9.4 10l5.3-5.4-2-2.1z" fill="currentColor" />
  </svg>
);

export default SvgArrowBack2;
